/* Upgrades the collection sort <select> into a themed listbox.
   WAI-ARIA select-only combobox: button + role="listbox", active option tracked
   with aria-activedescendant so focus can stay on the list. */
(function () {
  'use strict';

  var TYPEAHEAD_RESET = 500;

  function init(root) {
    var select = root.querySelector('select');
    if (!select || root.dataset.sortReady) return;
    root.dataset.sortReady = '1';

    var labelId = root.querySelector('.visually-hidden') ? root.querySelector('.visually-hidden').id : '';
    var options = Array.prototype.map.call(select.options, function (o) {
      return { value: o.value, label: o.textContent.trim(), selected: o.selected };
    });
    if (!options.length) return;

    var selectedIndex = options.findIndex(function (o) { return o.selected; });
    if (selectedIndex < 0) selectedIndex = 0;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sortbtn';
    btn.id = 'amphr-sort-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', 'amphr-sort-menu');
    btn.setAttribute('aria-labelledby', (labelId ? labelId + ' ' : '') + btn.id);
    btn.textContent = options[selectedIndex].label;

    var list = document.createElement('ul');
    list.className = 'sortmenu';
    list.id = 'amphr-sort-menu';
    list.setAttribute('role', 'listbox');
    list.setAttribute('tabindex', '-1');
    if (labelId) list.setAttribute('aria-labelledby', labelId);
    list.hidden = true;

    var items = options.map(function (o, i) {
      var li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.id = 'amphr-sort-opt-' + i;
      li.dataset.value = o.value;
      li.setAttribute('aria-selected', i === selectedIndex ? 'true' : 'false');
      li.textContent = o.label;
      list.appendChild(li);
      return li;
    });

    select.remove();
    root.appendChild(btn);
    root.appendChild(list);

    var activeIndex = selectedIndex;
    var typed = '';
    var typedTimer = null;

    function setActive(i) {
      if (i < 0 || i >= items.length) return;
      if (items[activeIndex]) items[activeIndex].classList.remove('is-active');
      activeIndex = i;
      items[i].classList.add('is-active');
      list.setAttribute('aria-activedescendant', items[i].id);
      var top = items[i].offsetTop;
      var bottom = top + items[i].offsetHeight;
      if (top < list.scrollTop) list.scrollTop = top;
      else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight;
    }

    function isOpen() { return !list.hidden; }

    var GAP = 8;

    function place() {
      list.classList.remove('sortmenu--up');
      list.style.maxHeight = '';
      var anchor = btn.getBoundingClientRect();
      var needed = list.scrollHeight;
      var below = window.innerHeight - anchor.bottom - GAP;
      var above = anchor.top - GAP;
      if (needed <= below) return;
      if (needed <= above || above > below) {
        list.classList.add('sortmenu--up');
        if (needed > above) list.style.maxHeight = Math.max(above, 132) + 'px';
      } else {
        list.style.maxHeight = Math.max(below, 132) + 'px';
      }
    }

    /* Spatiul de deasupra si de dedesubt se schimba la scroll, deci decizia de
       flip se invecheste cat timp meniul e deschis. */
    var reflow = function () { if (isOpen()) place(); };

    function open(startIndex) {
      if (isOpen()) return;
      list.hidden = false;
      place();
      btn.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
      setActive(typeof startIndex === 'number' ? startIndex : selectedIndex);
      list.focus();
      window.addEventListener('scroll', reflow, { passive: true });
      window.addEventListener('resize', reflow);
    }

    function close(returnFocus) {
      if (!isOpen()) return;
      window.removeEventListener('scroll', reflow);
      window.removeEventListener('resize', reflow);
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      list.removeAttribute('aria-activedescendant');
      items[activeIndex] && items[activeIndex].classList.remove('is-active');
      if (returnFocus) btn.focus();
    }

    function commit(i) {
      var value = options[i].value;
      if (i === selectedIndex) { close(true); return; }
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', value);
      params.delete('page');
      window.location.href = window.location.pathname + '?' + params.toString();
    }

    function matchTyped(ch) {
      window.clearTimeout(typedTimer);
      typed += ch.toLowerCase();
      typedTimer = window.setTimeout(function () { typed = ''; }, TYPEAHEAD_RESET);
      /* Start after the active option so repeated presses of one letter cycle. */
      var start = typed.length === 1 ? activeIndex + 1 : activeIndex;
      for (var n = 0; n < items.length; n++) {
        var i = (start + n) % items.length;
        if (options[i].label.toLowerCase().indexOf(typed) === 0) { setActive(i); return; }
      }
    }

    btn.addEventListener('click', function () {
      if (isOpen()) close(true); else open();
    });

    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        open();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        open(selectedIndex);
      }
    });

    list.addEventListener('keydown', function (e) {
      switch (e.key) {
        case 'ArrowDown': e.preventDefault(); setActive(Math.min(activeIndex + 1, items.length - 1)); break;
        case 'ArrowUp': e.preventDefault(); setActive(Math.max(activeIndex - 1, 0)); break;
        case 'Home': e.preventDefault(); setActive(0); break;
        case 'End': e.preventDefault(); setActive(items.length - 1); break;
        case 'Escape': e.preventDefault(); close(true); break;
        case 'Tab': close(false); break;
        case 'Enter':
        case ' ':
        case 'Spacebar': e.preventDefault(); commit(activeIndex); break;
        default:
          if (e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey) {
            e.preventDefault();
            matchTyped(e.key);
          }
      }
    });

    list.addEventListener('click', function (e) {
      var li = e.target.closest('[role="option"]');
      if (!li) return;
      commit(items.indexOf(li));
    });

    document.addEventListener('click', function (e) {
      if (isOpen() && !root.contains(e.target)) close(false);
    });

    list.addEventListener('focusout', function (e) {
      if (isOpen() && !root.contains(e.relatedTarget)) close(false);
    });
  }

  function boot() {
    document.querySelectorAll('[data-sort]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
